export const ADD_AI_INVOICE = "ADD_AI_INVOICE"
export const UPDATE_AI_INVOICE = "UPDATE_AI_INVOICE"
export const DELETE_AI_INVOICE = "DELETE_AI_INVOICE"
